// https://github.com/algolia/places/issues/847
// Browser shim for module-level code that probes `process.env` (Algolia
// places). Imported FIRST from main.ts so it runs before any app module.
// This used to live in src/polyfills.ts, but @angular/build's isZonelessApp
// heuristic treats ANY custom polyfill file as "app may need zone.js" and
// injects zone.js/node into the server bundle — which no longer resolves now
// that zone.js is uninstalled. An empty polyfills array keeps every bundle
// (browser, server, dev-server) genuinely zoneless.
(window as any).process = {
  env: { DEBUG: undefined },
};
